<template>
    <CardBorder :title="$t('views.request.hazDiscussProduct.mainSubStance')">
        <Button v-if="canCreate" class="btn-success mb-2" size="small" @click="() => onClickAdd()">
            <CIcon file="plus.svg"></CIcon>
            <span>{{ $t("button.createNew") }}</span>
        </Button>
        <template
            v-for="(record, index) in lodash.get(data.useForm.modelRef, itemsKey)"
            :key="record.id || record._id"
        >
            <CardBorder
                v-if="record.isDelete !== true"
                :style="{ marginBottom: index + 1 < lodash.get(data.useForm.modelRef, itemsKey).length ? '0.5rem !important' : '0rem !important' }"
            >
                <Button
                    v-if="canDelete"
                    class="btn-danger mb-2"
                    size="small"
                    @click="() => onClickDelete(record, index)"
                    :style="{ position: 'absolute', top: '10px', left: '10px' }"
                >
                    <CIcon file="delete.svg"></CIcon>
                </Button>
                <TemplateBuilder
                    :rowProp="data.rowProp"
                    :useForm="data.useForm"
                    :fields="createField({ props, data, key: `${itemsKey}.${index}`, isLoading })"
                    :skeleton="isLoading"
                ></TemplateBuilder>
            </CardBorder>
        </template>
        <div class="has-error" v-if="data.useForm.validateInfos[itemsKey]?.validateStatus === 'error'">
            <div class="ant-form-explain">
                {{ data.useForm.validateInfos[itemsKey]?.help }}
            </div>
        </div>
    </CardBorder>
</template>

<script>
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../../../app.logic";
import { initData, isLoading, createField } from "./haz-discuss-main-sub-stance.logic";
import lodash from "lodash";
import { Button } from "ant-design-vue";
import { randomUuid } from "../../../../../utils/util";
import { clearRulesStartsWith } from "../../../../../utils/validate";

export default defineComponent({
    components: {
        Button,
        //CTable: defineAsyncComponent(() => import("../../../../../components/table/CTable")),
        TemplateBuilder: defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder")),
        CIcon: defineAsyncComponent(() => import("../../../../../components/icon/CIcon")),
        CardBorder: defineAsyncComponent(() => import("../../../../../components/card/CardBorder"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: {},
        dataProp: {},
        itemsKey: {},
        fetchCriteria: {},
        canCreate: {},
        canDelete: {}
    },
    setup(props) {
        const data = reactive({ ...props.dataProp });
        const refs = reactive({});
        const onClickAdd = () => {
            lodash.get(data.useForm.modelRef, props.itemsKey).push({ 
                intense: null,
                microAnalysisQty1: null, 
                microAnalysisQty2: null, 
                microAnalysisQty3: null, 
                refMicroUnit: null,
                pictograms: [],
                refSubStance: null,
                _id: randomUuid() 
            });
        };
        const onClickDelete = (record, index) => {
            if (record.id) {
                record.isDelete = true;
            } else {
                Promise.resolve()
                    .then(() => clearRulesStartsWith({ useForm: data.useForm, key: `${props.itemsKey}.` }))
                    .then(() => lodash.get(data.useForm.modelRef, props.itemsKey).splice(index, 1));
            }
        };
        initData({ props, data, refs });
        return { props, data, refs, isLoading, lodash, createField, onClickAdd, onClickDelete };
    }
});
</script>
